import React from 'react';
import { Box, Grid, IconButton, Modal, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import TimerOutlinedIcon from '@mui/icons-material/TimerOutlined';
import { COLOR_PRIMARY_2 } from 'src/colors';

const styles = {
  filterModalBodyRoot: {
    position: 'relative',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 'clamp(300px, 70vw, 700px)',
    bgcolor: 'background.paper',
    border: 'none',
    outline: 'none',
    boxShadow: 24,
    p: 4,
    borderRadius: '20px',
    maxHeight: '80vh',
    overflowY: 'auto',
  },
  filterModalCloseIcon: {
    position: 'absolute',
    top: '5px',
    right: '5px',
    cursor: 'pointer',
  },
};

const ComingSoonModal = ({
  open,
  setOpen,
}: {
  open: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
}) => {
  const handleClose = () => {
    setOpen(false);
  };

  return (
    <div>
      <Modal open={open}>
        <Box sx={{ ...styles.filterModalBodyRoot, width: 'clamp(200px, 70vw, 300px)' }}>
          <IconButton onClick={handleClose} sx={styles.filterModalCloseIcon}>
            <CloseIcon />
          </IconButton>

          <Grid
            container
            item
            xs={12}
            direction="row"
            alignItems="center"
            gap={1}
            justifyContent="center"
            sx={{ mt: 1 }}
          >
            <Grid item>
              <Typography variant="h6" sx={{ fontWeight: 'bold', color: COLOR_PRIMARY_2 }}>
                Coming soon!
              </Typography>
            </Grid>
            <Grid item>
              <TimerOutlinedIcon sx={{ color: COLOR_PRIMARY_2 }} />
            </Grid>
          </Grid>
        </Box>
      </Modal>
    </div>
  );
};

export default ComingSoonModal;
